import { render, staticRenderFns } from "./McqScore.vue?vue&type=template&id=1fd070f3&scoped=true"
import script from "./McqScore.vue?vue&type=script&lang=js"
export * from "./McqScore.vue?vue&type=script&lang=js"
import style0 from "./McqScore.vue?vue&type=style&index=0&id=1fd070f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd070f3",
  null
  
)

export default component.exports